
export class OperationTimeConsModel {
    operationId: string;
    operationDesc: string;
    timeConsumed: number; // in seconds DESC orders
    isLastOperation: boolean;

    noOfOperators: number; // count of all dist emp ids in line_actual_track group by style, op, date     


    constructor( operationId: string,
        operationDesc: string,
        timeConsumed: number,
        isLastOperation: boolean,
        noOfOperators: number) {
            this.operationId = operationId;
            this.operationDesc = operationDesc;
            this.timeConsumed = timeConsumed;
            this.isLastOperation = isLastOperation;
            this.noOfOperators = noOfOperators;
    }
}
